export default __webpack_public_path__ + "static/media/Avatar-26.3047a3f8.svg";